import { Component, OnInit, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders }  from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { API_BASE_URL } from '../../environments/environment';
import { DateAdapter, MatDatepicker, MatDatepickerInputEvent, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDialog } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { BaseComponent } from '../base.component';
import { StaffDetailDialogComponent } from '../staffs/staff-detail-dialog/staff-detail-dialog.component';
import { ExportHistoryDialogComponent } from './export-history-dialog/export-history-dialog.component';
import { DaysEditDialogComponent, DaysEditDialogResult } from './days-edit-dialog/days-edit-dialog.component';
import { formatDays, parseDays } from './paid-holiday-days';

// 「年月指定」フォーマット
export const YEAR_MONTH_FORMATS = {
  parse: {
    dateInput: 'YYYY年MM月',
  },
  display: {
    dateInput: 'YYYY年MM月',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-paid-holiday',
  templateUrl: './paid-holiday.component.html',
  styleUrls: ['./paid-holiday.component.less'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: YEAR_MONTH_FORMATS},
  ]
})

export class PaidHolidayComponent extends BaseComponent implements OnInit {
  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  userName = localStorage.getItem("userName") || localStorage.getItem("uid");

  // テーブルのカラム名
  columnDefs = [
    'name',
    'printFirst',
    'printTel',
    'printRepeat',
    'allRemainingCount',
    'remainingUseObligation',
    'nameSite',
    'note',
    'expirationDate',
    'toStaffDetail',
    'printed',
    'returned'
  ];

  // 出力中の表示
  nowPrinting = false;

  // エクスポート時の内容
  // @ViewChild('TABLE') table: ElementRef;

  // テーブルのデータソース
  paidHolidayList = new MatTableDataSource();

  // エクスポート用データ
  exportData = [];

  // ローディング中の表示
  nowLoading = true;

  // エクスポート用ローディング
  loadingExport = true;

  // リストの件数
  totalCount = 0;

  /**
   * 「返送済み」にチェックが入っている件数
   */
  get returnedCount(): number {
    return (this.paidHolidayList.data as any[]).filter(row => row.isReturned).length;
  }

  /**
   * 「要注意行」（指定日候補が使用義務残数に足りていない）の件数
   */
  get cautionCount(): number {
    return (this.paidHolidayList.data as any[]).filter(row => row.isCaution).length;
  }

  // 指定年月
  selectedMonthYear = new FormControl(moment());

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private dialog2: MatDialog,
    private ngZone: NgZone,
    private snackBar: MatSnackBar
    ) {
    super();
  }

  ngOnInit() {
    this.getPaidHolidayList();
  }

  goTo(comp, param){
    this.ngZone.run(()=>{
    this.router.navigate([comp, param])
    });
  }

  /**
   * 「指定年月」手入力した場合
   * @param normalized 入力した年月
   */
  handlerManual(normalized: MatDatepickerInputEvent<moment.Moment>) {
    // イベントの中の値（moment）を入れる。読めない入力（空・文字）は null なので何もしない
    // （前はイベントそのものを入れていて、欄が空になり今月で取り直していた）
    if (!normalized || !normalized.value) {
      return;
    }
    this.selectedMonthYear.setValue(normalized.value);
    this.getPaidHolidayList();
  }

  /**
   * 「指定年月」datepickerで年を選択した場合
   * @param normalized 選択した年月
   */
  chosenYearHandler(normalized: moment.Moment) {
    this.selectedMonthYear.setValue(normalized);
  }

  /**
   * 「指定年月」datepickerで月を選択した場合
   * @param normalized 選択した年月
   * @param datepicker datepickerカレンダー
   */
  chosenMonthHandler(normalized: moment.Moment, datepicker: MatDatepicker<moment.Moment>) {
    this.selectedMonthYear.setValue(normalized);
    datepicker.close();
    this.getPaidHolidayList();
  }

  /**
   * リストのデータ取得
   */
  getPaidHolidayList() {
    this.nowLoading = true;
    this.loadingExport = true;
    const date = moment(this.selectedMonthYear.value).format('YYYY-MM-01');
    this.http.get(
      API_BASE_URL + '/api/v1/paidHolidays/usingObligation?date=' + date,
      {headers: this.headers}
    )
    .subscribe(res => {
      let data = res as any[];
      // 「該当なし」表示用のダミー行を含めない件数
      this.totalCount = data.length;
      if (data.length == 0) {
        this.exportData = [];
        data.push({
          name :  '-',
          allRemainingCount : '-',
          remainingUseObligation : '-',
          expirationDate : '-'
        })
      } else {
        // エクセル用にカラムを生成
        this.exportData = data.map(a => ({
            '清掃員名': a['name']
          , '有休残数': a['allRemainingCount']
          , '使用義務残数': a['remainingUseObligation']
          , '使用期限日': this.formatExpirationDateForExport(a['expirationDate'])
        }));
      }
      this.paidHolidayList = new MatTableDataSource(data);
      this.nowLoading = false;
      this.loadingExport = false;
    },
    error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 「初回」チェック変更
   */
  selectFirst(row: any, checked: boolean) {
    this.changePrintSelection([row], target => this.applyFirst(target, checked));
  }

  /**
   * 「2回目以降」チェック変更
   */
  selectRepeat(row: any, checked: boolean) {
    this.changePrintSelection([row], target => this.applyRepeat(target, checked));
  }

  /**
   * 「TEL」チェック変更
   * 「初回」「2回目以降」とは独立した目印なので、他の列のチェック状態には影響しない
   * 電話した記録なので、対象者リストから外れた行（グレー表示）でも操作できる
   */
  selectTel(row: any, checked: boolean) {
    this.changePrintSelection([row], target => this.applyTel(target, checked));
  }

  /**
   * 「初回」のチェック状態を行に反映（保存は行わない）
   */
  private applyFirst(row: any, checked: boolean) {
    row.selectedFirst = checked;
    if (checked) {
      row.selectedRepeat = false;
    }
  }

  /**
   * 「2回目以降」のチェック状態を行に反映（保存は行わない）
   */
  private applyRepeat(row: any, checked: boolean) {
    row.selectedRepeat = checked;
    if (checked) {
      row.selectedFirst = false;
    }
  }

  /**
   * 「TEL」のチェック状態を行に反映（保存は行わない）
   */
  private applyTel(row: any, checked: boolean) {
    row.isTel = checked;
  }

  /**
   * 「初回」「TEL」「2回目以降」のチェック操作
   * 画面表示時の初期値では呼ばれないため、ここを通るのはユーザーが操作した場合のみ
   * @param rows 操作対象の行
   * @param apply 行へのチェック状態の反映
   */
  private changePrintSelection(rows: any[], apply: (row: any) => void) {
    if (rows.length == 0) {
      return;
    }
    rows.forEach(row => apply(row));
    this.savePrintSelection(rows);
  }

  /**
   * チェックを操作した行、または指定日候補・備考を編集した行を保存
   * チェック状態だけでなく、その行が持つデータ（指定日候補・備考・編集済みフラグを含む）を全て送る
   * 保存に失敗した場合はサーバーの状態に合わせるためリストを再取得する
   * @param rows 保存対象の行
   * @param onSuccess 保存成功時の処理（省略可）
   */
  private savePrintSelection(rows: any[], onSuccess?: () => void) {
    let targetYearMonth = moment(this.selectedMonthYear.value).format('YYYY-MM-DD');
    this.http.post(
      API_BASE_URL + '/api/v1/paidHolidays/printedStaff/selection',
      {
        targetYearMonth: targetYearMonth,
        updateUser: this.userName,
        staffs: rows.map(row => ({
          ...row,
          selectedFirst: !!row.selectedFirst,
          selectedRepeat: !!row.selectedRepeat,
          isTel: !!row.isTel,
          isReturned: !!row.isReturned,
          isPrinted: !!row.isPrinted,
          isDaysEdited: !!row.isDaysEdited
        }))
      },
      {headers: this.headers}
    )
    .subscribe(() => {
      if (onSuccess) {
        onSuccess();
      }
    },
    error => {
      alert("更新に失敗しました");
      this.getPaidHolidayList();
    });
  }

  /**
   * チェック操作の対象となる行（対象者リストから外れた行は除く）
   */
  private eligibleRows(): any[] {
    return (this.paidHolidayList.data as any[]).filter(row => row.staffDailyCleaning && !row.isDroppedOff);
  }

  /**
   * 「TEL」のチェック操作の対象となる行
   * TELは電話した記録なので、対象者リストから外れた行（グレー表示）も含める。「該当なし」のダミー行だけ除く
   */
  private telRows(): any[] {
    return (this.paidHolidayList.data as any[]).filter(row => row.staffDailyCleaning);
  }

  /**
   * 「初回」列のヘッダーチェックボックスの状態（対象行が全てチェック済みならtrue）
   */
  isAllFirstChecked(): boolean {
    let rows = this.eligibleRows();
    return rows.length > 0 && rows.every(row => row.selectedFirst);
  }

  /**
   * 「TEL」列のヘッダーチェックボックスの状態（対象行が全てチェック済みならtrue）
   */
  isAllTelChecked(): boolean {
    let rows = this.telRows();
    return rows.length > 0 && rows.every(row => row.isTel);
  }

  /**
   * 「2回目以降」列のヘッダーチェックボックスの状態（対象行が全てチェック済みならtrue）
   */
  isAllRepeatChecked(): boolean {
    let rows = this.eligibleRows();
    return rows.length > 0 && rows.every(row => row.selectedRepeat);
  }

  /**
   * 「初回」列の全選択・全解除
   */
  toggleAllFirst(checked: boolean) {
    this.changePrintSelection(this.eligibleRows(), row => this.applyFirst(row, checked));
  }

  /**
   * 「TEL」列の全選択・全解除
   */
  toggleAllTel(checked: boolean) {
    this.changePrintSelection(this.telRows(), row => this.applyTel(row, checked));
  }

  /**
   * 「2回目以降」列の全選択・全解除
   */
  toggleAllRepeat(checked: boolean) {
    this.changePrintSelection(this.eligibleRows(), row => this.applyRepeat(row, checked));
  }

  /**
   * 「返送済み」チェック変更
   * 保存に失敗した場合はサーバーの状態に合わせるためリストを再取得する
   */
  toggleReturned(row: any, checked: boolean) {
    row.isReturned = checked;
    let targetYearMonth = moment(this.selectedMonthYear.value).format('YYYY-MM-DD');
    this.http.post(
      API_BASE_URL + '/api/v1/paidHolidays/printedStaff/returned',
      {
        staffDailyCleaning: row.staffDailyCleaning,
        targetYearMonth: targetYearMonth,
        isReturned: checked,
        updateUser: this.userName
      },
      {headers: this.headers}
    )
    .subscribe(() => {
    },
    error => {
      alert("更新に失敗しました");
      this.getPaidHolidayList();
    });
  }

  /**
   * チェックした対象者分のWordをまとめて出力
   */
  printDocument() {
    let targets = (this.paidHolidayList.data as any[])
      .filter(row => row.staffDailyCleaning && !row.isDroppedOff && (row.selectedFirst || row.selectedRepeat))
      .map(row => ({
        staffDailyCleaning: row.staffDailyCleaning,
        remainingUseObligation: row.remainingUseObligation,
        sequenceNumber: row.sequenceNumber,
        cdSite: row.cdSite,
        nameSite: row.nameSite,
        days: row.days,
        templateType: row.selectedFirst ? 'first' : 'repeat'
      }));

    if (targets.length == 0) {
      alert("対象者を選択してください");
      return;
    }

    this.nowPrinting = true;
    let targetYearMonth = moment(this.selectedMonthYear.value).format('YYYY-MM-DD');
    this.http.post(
      API_BASE_URL + '/api/v1/paidHolidays/printDocument?date=' + targetYearMonth
        + '&updateUser=' + encodeURIComponent(this.userName || ''),
      targets,
      {headers: this.headers, responseType: 'blob' as 'json'}
    )
    .subscribe(res => {
      let data = res as any;
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = '有休5日確認書類' + moment().format('_YYYY.MM.DD') + '.docx';
      link.click();
      this.nowPrinting = false;
      this.getPaidHolidayList();
    },
    error => {
      alert("出力に失敗しました");
      this.nowPrinting = false;
    });
  }

  /**
   * 残数出力
   */
  leftXlsx() {
    this.loadingExport = true;
    let title = '有給残数' + moment().format('_YYYY.MM.DD');

    this.http.get(
      API_BASE_URL + '/api/v1/paidHolidays/downloadLeft',
      {headers: this.headers, responseType : 'blob' as 'json'}
    )
    .subscribe(res => {
      let data = res as any;
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;

      // ダウンロードしたファイル名
      link.download = title + '.xlsx';

      link.click();
    },
    error => {
      alert("認証に失敗しました\r\n" + error);
      this.router.navigate(['/']);
      this.loadingExport = false;
    });
    this.loadingExport = false;
  }

  /**
   * 使用履歴出力
   */
  historyXlsx() {
    this.dialog2.open(ExportHistoryDialogComponent, {});
  }

  /**
   * エクスポート
   */
  exportXlsx() {
    const ws: XLSX.WorkSheet=XLSX.utils.json_to_sheet(this.exportData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, '有休5日使用義務.xlsx');
  }

  /**
   * 「使用期限日」画面表示用フォーマット
   * "2026-11-01 00:00:00.0" → "2026/11/01"
   * @param value APIから受け取った使用期限日
   */
  formatExpirationDate(value: any): string {
    return this.formatExpirationDateBy(value, 'YYYY/MM/DD');
  }

  /**
   * 「使用期限日」エクセル出力用フォーマット
   * "2026-11-01 00:00:00.0" → "2026-11-01"
   * @param value APIから受け取った使用期限日
   */
  private formatExpirationDateForExport(value: any): string {
    return this.formatExpirationDateBy(value, 'YYYY-MM-DD');
  }

  /**
   * 「使用期限日」のフォーマット
   * 時差でずれないよう、先頭の日付部分だけを見て変換する
   * @param value APIから受け取った使用期限日
   * @param format 変換後のフォーマット
   */
  private formatExpirationDateBy(value: any, format: string): string {
    if (!value) {
      return '';
    }
    let m = moment(String(value).substring(0, 10), 'YYYY-MM-DD', true);
    if (!m.isValid()) {
      // 「該当なし」のダミー行など、日付以外はそのまま表示する
      return String(value);
    }
    return m.format(format);
  }

  /**
   * 清掃員名クリック時の稼働管理画面へのリンク
   * 「指定日候補」があれば最初の日〜最後の日、なければ「指定年月」の月初〜月末を期間に指定する
   * @param row リストの行
   */
  operationLink(row: any): any[] {
    let list = parseDays(row.days);
    let start: string;
    let end: string;
    if (list.length > 0) {
      start = list[0];
      end = list[list.length - 1];
    } else {
      start = moment(this.selectedMonthYear.value).startOf('month').format('YYYY-MM-DD');
      end = moment(this.selectedMonthYear.value).endOf('month').format('YYYY-MM-DD');
    }
    return ['/operations', 'false', start, end];
  }

  /**
   * 「指定日候補」表示用フォーマット
   * "{2026-08-30,2026-09-06}" → "8/30(日)、9/6(日)"
   * @param days APIから受け取った日付の集合
   */
  formatDays(days: any): string {
    return formatDays(days);
  }

  /**
   * 「指定日候補」を編集できる行か
   * 対象者リストから外れた行（グレー表示）と「該当なし」のダミー行は編集不可
   * @param row リストの行
   */
  isDaysEditable(row: any): boolean {
    return !!row.staffDailyCleaning && !row.isDroppedOff;
  }

  /**
   * 「指定日候補」セルクリックイベント　編集ダイアログを開く
   * ダイアログの編集結果を行に反映し、変更した日付の履歴を備考に追記して、
   * 初回・TEL・2回目以降と同じ保存APIで行ごと保存する
   * 保存後は、要注意判定などをサーバーの状態に合わせるためリストを再取得する
   * @param row リストの行
   */
  editDays(row: any) {
    if (!this.isDaysEditable(row)) {
      return;
    }
    this.dialog.open(DaysEditDialogComponent, {
      data: {
        row: row,
        targetYearMonth: moment(this.selectedMonthYear.value).format('YYYY-MM-DD'),
        updateUser: this.userName
      }
    })
    .afterClosed().subscribe((result: DaysEditDialogResult) => {
      if (!result) {
        return;
      }
      row.days = result.days;
      // 一度変更済みになったら下ろさない
      row.isDaysEdited = !!row.isDaysEdited || result.isDaysEdited;
      // 変更した日付の履歴を備考の末尾に追記（既に文字があれば改行してから）
      if (result.history) {
        let note = (row.note || '').replace(/\s+$/, '');
        row.note = note ? note + '\n' + result.history : result.history;
      }
      this.savePrintSelection([row], () => this.getPaidHolidayList());
    });
  }

  /**
   * 「備考」セルの入力欄からフォーカスが外れた（内容が変わった）ときに保存
   * 備考はどの行でも編集できる（対象者リストから外れた行も含む）
   * 表で直接編集するため、ダイアログは使わない。保存できたら「保存しました。」を表示する
   * @param row リストの行
   */
  saveNote(row: any) {
    this.savePrintSelection([row], () => {
      // エリアマスタの保存時と同じ表示（位置は画面上部の中央）
      this.snackBar.open('保存しました。', '閉じる', {
        duration: 1000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['custom-snackbar']
      });
    });
  }

  /**
   * 名前クリックイベント　稼働管理へ遷移
   * @param name 清掃員名
   */
  toOperationPage(name: string) {
    localStorage.setItem('search_staffs_name', name);
  }

  /**
   * 詳細クリックイベント
   */
  staffDetailDialogOpen(event: any) {
    this.dialog.open(StaffDetailDialogComponent, {
      data: {
        data: event
      }
    });
  }
}
